import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import './App.css';
import Home from './components/Home/Home';
import Nosotros from './components/Nosotros/Nosotros';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Balances from './components/Balances/Balances';
import Cerfitificaciones from './components/Certificaciones/Cerfitificaciones';
import Escuela from './components/Escuela/Escuela';
import EscuelaInfo from './components/Escuela/EscuelaInfo';
import EscuelaInscripcion from './components/Escuela/EscuelaInscripcion';
import Productos from './components/Productos/Productos';
import Landing from './components/Landing/Landing';
import DescargarFormularios from './components/DescargarFormularios/DescargarFormularios';
import PolizaDigital from './components/PolizaDigital/PolizaDigital';
import EscuelaPrograma from './components/Escuela/EscuelaPrograma';
import Fraude from './components/Fraude/Fraude';
import Contacto from './components/Contacto/Contacto';
import TrabajaConNosotros from './components/TrabajaConNosotros/TrabajaConNosotros';
import NuevoCotizadorAlquiler from './components/NuevoCotizadorAlquiler/NuevoCotizadorAlquiler';
import Prensa from './components/Prensa/Prensa';
import CotizadorDirectores from './components/CotizadorDirectores/CotizadorDirectores';
import { Icon } from '@iconify/react';
import ScrollToTop from './components/utils/ScrollToTop';
import Carrousel from './components/Nosotros/Carrousel';
import { Provider } from './Context/LangContext';
import PrensaDetail from './components/Prensa/PrensaDetail';
import PolizaExecute from './components/PolizaDigital/PolizaExecute';
import Lavado from './components/Lavado/Lavado';
import DataProtection from './components/DataProtection/DataProtection';

function App() {
  return (
    <Provider>
    <BrowserRouter>
    <Header />
      <Routes>
        <Route exact path="/data-protection" element={<DataProtection />}></Route>
        <Route exact path="/carrousel" element={<Carrousel />}></Route>
        <Route exact path="/cotizador-directores" element={<CotizadorDirectores />}></Route>
        <Route exact path="/cotizador-alquiler" element={<NuevoCotizadorAlquiler />}></Route>
        <Route exact path="/trabaja-con-nosotros" element={<TrabajaConNosotros />}></Route>
        <Route exact path="/prensa-detail/:id" element={<PrensaDetail />}></Route>
        <Route exact path="/prensa" element={<Prensa />}></Route>
        <Route exact path="/contacto" element={<Contacto />}></Route>
        <Route exact path="/lavado" element={<Lavado />}></Route>
        <Route exact path="/prevencion-fraude" element={<Fraude />}></Route>
        <Route exact path="/productos/poliza-execute" element={<PolizaExecute />}></Route>
        <Route exact path="/productos/poliza-digital" element={<PolizaDigital />}></Route>
        <Route exact path="/productos/descargar-formularios" element={<DescargarFormularios />}></Route>
        <Route exact path="/landing" element={<Landing />} />
        <Route exact path="/escuela/programa" element={<EscuelaPrograma />} />
        <Route exact path="/escuela/inscripcion" element={<EscuelaInscripcion />} />
        <Route exact path="/escuela/info" element={<EscuelaInfo />} />
        <Route exact path="/escuela" element={<Escuela />} />
        <Route exact path="/productos/:id" element={<Productos />} />
        <Route exact path="/certificaciones" element={<Cerfitificaciones />} />
        <Route exact path="/balances" element={<Balances />} />
        <Route exact path="/nosotros" element={<Nosotros />} />
        <Route exact path="/" element={<Home />} />
      </Routes> 
     <Footer />
      <a href="https://wa.me/5491160023137?text=Hola! Necesito información sobre un seguro de caucion de..." className="floating" target="_blank" rel="noreferrer">
      <Icon icon="logos:whatsapp-icon" className='icon' />
      </a>
      <ScrollToTop />
    </BrowserRouter>
    </Provider>

  );
}

export default App;
